import { IDashboardChartPayload } from 'components/domain/dashboard/dashboard-card-chart/types/types';
import { useEquipmentHours } from 'hooks';
import sumBy from 'lodash/sumBy';
import { DateTime } from 'luxon';
import { useCallback, useState } from 'react';
import ITimeRange from 'types/TimeRange';

export default function useDashboardEquipmentHours(
  timeRange: ITimeRange<DateTime>,
  ranges: Array<ITimeRange<number>>,
  equipmentId?: string | null
) {
  const { getMachineHours } = useEquipmentHours();
  const [data, setData] = useState<Array<IDashboardChartPayload & { value: number }>>([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getData = useCallback(async () => {
    const promises = ranges.map<Promise<IDashboardChartPayload & { value: number }>>(async (r) => {
      const newRange: ITimeRange<DateTime> = {
        startTime: DateTime.fromSeconds(r.startTime).toUTC(),
        endTime: DateTime.fromSeconds(r.endTime).toUTC(),
      };
      const hours = await getMachineHours(newRange, equipmentId);
      return { day: r.startTime, value: Number(hours.toFixed(1)) };
    });
    setIsLoading(true);
    await Promise.all(promises)
      .then((results) => {
        setData(results);
        setIsLoading(false);
      })
      .catch((e) => setError(e));
  }, [timeRange, equipmentId, ranges]);

  return {
    data,
    total: data ? sumBy(data, (datum) => datum.value) : 0,
    loading: isLoading,
    error,
    execute: getData,
  };
}
